export default __webpack_public_path__ + "static/media/logo.92530258.svg";